<!-- <template>
    <div class="page">
        <div class="header">
            <img class="logo" src="../../../assets/images/blv.png" alt="">
            <div class="lv">绿萝分发</div>
            <div class="navigation" @mouseover="showDropdown(0)" @mouseleave="hideDropdown">
                <div @click="gotoPage('index')" :class="{ active: activeIndex === 0 }">首页</div>
                <div @mouseover="showDropdown(1)" class="dropdown" @mouseleave="hideDropdown"
                    :class="{ active: activeIndex === 1 }">
                    用户中心
                    <div v-if="showDropdownMenu || currentIndex === 1" class="dropdown-menu">
                        <div @mouseover="changeImage('cpjs')" @mouseleave="resetImage">
                            <img :src="currentImage === 'cpjs' ? cpjsHoverSrc : cpjsSrc" alt="">产品介绍
                        </div>
                        <div @mouseover="changeImage('sc')" @mouseleave="resetImage">
                            <img :src="currentImage === 'sc' ? scHoverSrc : scSrc" alt="">使用手册
                        </div>
                    </div>
                </div>
                <div @click="gotoPage('aiClip')" @mouseover="showDropdown(2)" @mouseleave="hideDropdown"
                    :class="{ active: activeIndex === 2 }">AI混剪
                </div>
                <div @click="gotoPage('help')" @mouseover="showDropdown(3)" @mouseleave="hideDropdown"
                    :class="{ active: activeIndex === 3 }">使用指南
                </div>
                <div @click="gotoPage('vip')" @mouseover="showDropdown(4)" @mouseleave="hideDropdown"
                    :class="{ active: activeIndex === 4 }">
                    了解VIP</div>
                <div @click="gotoPage('regarding')" @mouseover="showDropdown(5)" @mouseleave="hideDropdown"
                    :class="{ active: activeIndex === 5 }">关于绿萝
                </div>
            </div>
            <div class="client">下载客户端</div>

        </div>
        <div class="headContentBar" v-if="show">
            <div class="privateDomain">私域加粉必备神器！自媒体平台/APP/浏览器/短信一键跳转</div>
            <div class="getToKnowNow">立即了解</div>
        </div>
    </div>
</template> -->
<template>
  <div class="page">
    <div class="header">
      <img
        class="logo"
        src="../../../assets/images/blv.png"
        alt=""
        @click="gotoPage('index')"
      />
      <div class="lv" @click="gotoPage('index')">绿萝分发</div>
      <div
        class="navigation"
        @mouseover="showDropdown(0)"
        @mouseleave="hideDropdown"
      >
        <div @click="gotoPage('index')" :class="{ active: activeIndex === 0 }">
          首页
        </div>
        <div
          @mouseover="showDropdown(1)"
          class="dropdown"
          @mouseleave="hideDropdown"
          :class="{ active: activeIndex === 1 }"
        >
          用户中心
          <div
            v-if="showDropdownMenu || currentIndex === 1"
            class="dropdown-menu"
          >
            <div
              @mouseover="changeImage('cpjs')"
              @mouseleave="resetImage"
              @click="
                configStore.downloadFile(
                  configStore.introduceUrl,
                  configStore.introduceName
                )
              "
            >
              <img
                :src="currentImage === 'cpjs' ? cpjsHoverSrc : cpjsSrc"
                alt=""
              />产品介绍
            </div>
            <div
              @mouseover="changeImage('sc')"
              @mouseleave="resetImage"
              @click="
                configStore.downloadFile(
                  configStore.manualUrl,
                  configStore.manualName
                )
              "
            >
              <img
                :src="currentImage === 'sc' ? scHoverSrc : scSrc"
                alt=""
              />使用手册
            </div>
          </div>
        </div>
        <div
          @mouseover="showDropdown(2)"
          class="dropdown"
          @mouseleave="hideDropdown"
          :class="{ active: activeIndex === 2 }"
          @click="gotoPage('aiClip')"
        >
          AI混剪
          <!-- <div
            v-if="showAIClipDropdownMenu || currentIndex === 2"
            class="dropdown-menu"
          >
            <div
              @mouseover="changeAIClipImage('clip1')"
              @mouseleave="resetAIClipImage"
            >
              <img
                :src="currentAIClipImage === 'clip1' ? clip1HoverSrc : clip1Src"
                alt=""
              />功能一
            </div>
            <div
              @mouseover="changeAIClipImage('clip2')"
              @mouseleave="resetAIClipImage"
            >
              <img
                :src="currentAIClipImage === 'clip2' ? clip2HoverSrc : clip2Src"
                alt=""
              />功能二
            </div>
          </div> -->
        </div>
        <div
          @click="gotoPage('help')"
          @mouseover="showDropdown(3)"
          @mouseleave="hideDropdown"
          :class="{ active: activeIndex === 3 }"
        >
          使用指南
        </div>
        <div
          @click="gotoPage('vip')"
          @mouseover="showDropdown(4)"
          @mouseleave="hideDropdown"
          :class="{ active: activeIndex === 4 }"
        >
          了解VIP
        </div>

        <div
          @click="gotoPage('regarding')"
          @mouseover="showDropdown(5)"
          @mouseleave="hideDropdown"
          :class="{ active: activeIndex === 5 }"
        >
          关于绿萝
        </div>
      </div>
      <div class="client hover-gesture" @click="configStore.downloadFile()">
        下载客户端
      </div>

      <a
        id="downloadLink"
        style="display: none"
        href="path/to/your/file.txt"
        download="file.txt"
        >Download</a
      >
    </div>
    <div class="headContentBar" v-if="show">
      <div class="privateDomain">
        私域加粉必备神器！自媒体平台/APP/浏览器/短信一键跳转
      </div>
      <div class="getToKnowNow">立即了解</div>
    </div>
  </div>
</template>
<!-- <script>
export default {
    name: 'headerss',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        activeIndex: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            showDropdownMenu: false,
            currentIndex: null,
            currentImage: '',
            cpjsSrc: require('../../../assets/images/cpjs.png'),
            cpjsHoverSrc: require('../../../assets/images/cpjssel.png'),
            scSrc: require('../../../assets/images/sc.png'),
            scHoverSrc: require('../../../assets/images/scsel.png')
        };
    },
    methods: {
        showDropdown(index) {
            this.currentIndex = index;
            if (index === 1) {
                this.showDropdownMenu = true;
            }

        },
        hideDropdown() {
            this.showDropdownMenu = false;
            this.currentIndex = null;
            this.resetImage();
        },
        changeImage(imageType) {
            this.currentImage = imageType;
        },
        resetImage() {
            this.currentImage = '';
        },
        gotoPage(pageName) {
            this.$router.push({ name: pageName });
        }

    }

}
</script> -->
<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useConfigStore } from "@/store/index";
const configStore = useConfigStore();

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  activeIndex: {
    type: Number,
    default: -1,
  },
});

const emit = defineEmits(["update:show", "update:activeIndex"]);

const showDropdownMenu = ref(false);
const showAIClipDropdownMenu = ref(false);
const currentIndex = ref(null);
const currentImage = ref("");
const currentAIClipImage = ref("");

const cpjsSrc = new URL("../../../assets/images/cpjs.png", import.meta.url)
  .href;
const cpjsHoverSrc = new URL(
  "../../../assets/images/cpjssel.png",
  import.meta.url
).href;
const scSrc = new URL("../../../assets/images/sc.png", import.meta.url).href;
const scHoverSrc = new URL("../../../assets/images/scsel.png", import.meta.url)
  .href;
const clip1Src = new URL("../../../assets/images/cpjs.png", import.meta.url)
  .href;
const clip1HoverSrc = new URL(
  "../../../assets/images/cpjssel.png",
  import.meta.url
).href;
const clip2Src = new URL("../../../assets/images/sc.png", import.meta.url).href;
const clip2HoverSrc = new URL(
  "../../../assets/images/scsel.png",
  import.meta.url
).href;

const router = useRouter();

const showDropdown = (index) => {
  currentIndex.value = index;
  if (index === 1) {
    showDropdownMenu.value = true;
  } else if (index === 2) {
    showAIClipDropdownMenu.value = true;
  }
};

const hideDropdown = () => {
  showDropdownMenu.value = false;
  showAIClipDropdownMenu.value = false;
  currentIndex.value = null;
  resetImage();
  resetAIClipImage();
};

const changeImage = (imageType) => {
  currentImage.value = imageType;
};

const resetImage = () => {
  currentImage.value = "";
};

const changeAIClipImage = (imageType) => {
  currentAIClipImage.value = imageType;
};

const resetAIClipImage = () => {
  currentAIClipImage.value = "";
};

const gotoPage = (pageName) => {
  router.push({ name: pageName });
};
</script>
<!-- <style lang="less" scoped>
/* 可选的样式部分 */
.page {
    width: 100%;

    .active {
        color: #6358ED;
    }

    .header {
        height: 100px;
        background: #FFFFFF;
        box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
            width: 18px;
            height: 36px;
            margin-right: 10px;
            margin-bottom: 10px;
        }

        .lv {
            width: 144px;
            height: 54px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 36px;
            color: #333333;
            line-height: 42px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-right: 96px;
        }

        .navigation {
            display: flex;
            gap: 60px;
            height: 27px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            div {
                cursor: pointer;
                user-select: none;

                &:hover {
                    color: #6358ED;
                }
            }


        }

        .client {
            width: 100px;
            height: 36px;
            background: #6358ED;
            border-radius: 4px 4px 4px 4px;
            color: white;
            text-align: center;
            line-height: 36px;
            margin-left: 161px;
            cursor: pointer;
        }
    }

    .headContentBar {
        height: 80px;
        background: #6358ED;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;

        .privateDomain {
            //padding-left: 360px;
            height: 36px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;

        }

        .getToKnowNow {
            width: 142px;
            height: 48px;
            background: #FF6842;
            border-radius: 4px 4px 4px 4px;
            margin-left: 432px;
            line-height: 48px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
        }
    }
}

.dropdown {
    position: relative;
}

.dropdown-menu {
    width: 120px;
    height: 96px;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 100%);
    font-weight: 400;
    font-size: 14px;
    color: #666666 !important;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10;

    img {
        width: 16px;
        height: 16px;
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 8px 0;
        width: 100%;

        &:hover {
            background: #f0effe;
        }

    }
}
</style> -->
<style lang="less" scoped>
/* 可选的样式部分 */
.page {
  width: 100%;

  .active {
    color: #6358ed;
  }

  .header {
    height: 100px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      width: 18px;
      height: 36px;
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .lv {
      width: 144px;
      height: 54px;
      // font-family: Source Han Sans CN, Source Han Sans CN;
      // font-weight: 500;
      font-family: 微软雅黑;
      font-weight: bold;
      font-size: 36px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 96px;
    }

    .navigation {
      display: flex;
      gap: 60px;
      height: 27px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      //  color: #666666;
      color: rgba(0, 0, 0, 1);
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      div {
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #6358ed;
        }
      }
    }

    .client {
      width: 100px;
      height: 36px;
      background: #6358ed;
      border-radius: 4px 4px 4px 4px;
      color: white;
      text-align: center;
      line-height: 36px;
      margin-left: 161px;
      cursor: pointer;
    }
  }

  .headContentBar {
    height: 80px;
    background: #6358ed;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    .privateDomain {
      height: 36px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .getToKnowNow {
      width: 142px;
      height: 48px;
      background: #ff6842;
      border-radius: 4px 4px 4px 4px;
      margin-left: 432px;
      line-height: 48px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
  }
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  width: 120px;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 100%);
  font-weight: 400;
  font-size: 14px;
  color: #666666 !important;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;

  img {
    width: 16px;
    height: 16px;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 0;
    width: 100%;

    &:hover {
      background: #f0effe;
    }
  }
}
</style>
